import ReactDOM from 'react-dom/client';
import { createHashRouter, Navigate, RouterProvider } from 'react-router-dom';
import { Api } from '@shared/types/api';
import { isElectron } from '@shared/utils/is-electron';
import { StoreInitializer } from '@ewf/components/StoreInitializer';
import { ExperimentalModeBanner } from '@ewf/components/ExperimentalModeBanner';
import { NewReleaseBanner } from '@ewf/components/NewReleaseBanner';
import { routerConst } from '@ewf/lib/router';
import { WelcomePage } from '@ewf/pages/Welcome';
import { DiscoverPage } from '@ewf/pages/Discover';
import { WorkerDetailsLitePage } from '@ewf/pages/WorkerDetailsLite';
import { DashboardPage } from '@ewf/pages/Dashboard';
import { DashboardDetails } from '@ewf/pages/DashboardDetails';
import { ErrorBoundary } from '@ewf/pages/ErrorBoundary';

export const router = createHashRouter([
  {
    path: routerConst.Home,
    element: isElectron() ? <WelcomePage /> : <Navigate to={routerConst.Discover} />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: routerConst.Discover,
    element: <DiscoverPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: `${routerConst.SolutionDetail}/:workerId`,
    element: <WorkerDetailsLitePage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: routerConst.Dashboard,
    element: <DashboardPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: `${routerConst.Dashboard}/:workerId`,
    element: <DashboardDetails />,
    errorElement: <ErrorBoundary />,
  },
]);

export const main = (injectedApiService: Api) =>
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <StoreInitializer injectedApiService={injectedApiService}>
      <RouterProvider router={router} />
      <ExperimentalModeBanner />
      <NewReleaseBanner />
    </StoreInitializer>,
  );
